import { useRuntimeConfig } from '#imports'

import type { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import type { Features } from '@backmarket/nuxt-module-marketplace/features'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { objectEntries } from '@backmarket/utils/object/objectEntries'

export function useBuybackEnabled() {
  const { features } = useMarketplace()
  const allFeatures = (useRuntimeConfig().public.marketplace?.features ??
    {}) as Record<MarketCountryCode, Features>

  const buybackAvailableMarketCodes = objectEntries(allFeatures)
    .filter(([, marketFeatures]) => marketFeatures?.buyback?.tradeInEnabled)
    .map(([marketCode]) => marketCode)

  const isBuybackEnabled = Boolean(features.buyback?.tradeInEnabled)
  const isBuybackButtonEnabled = Boolean(features.buyback?.headerButtonEnabled)

  return {
    isBuybackEnabled,
    isBuybackButtonEnabled,
    buybackAvailableMarketCodes,
  }
}
